import { ReactElement } from 'react';

import { useTranslation } from 'react-i18next';
import { AppBarTitlePortal } from '../../../../common/components/atoms/AppBarTitlePortal';
import { usePublicFileExplorer } from '../core/repositories/publicFiles/hook';
import FileExplorer from '../molecules/FileExplorer';

export default function PublicReports(): ReactElement {
  const { t } = useTranslation('Repository');
  const fileExplorerProps = usePublicFileExplorer();

  return (
    <>
      <AppBarTitlePortal>
        <h4>{t('Title')}</h4>
      </AppBarTitlePortal>
      <FileExplorer {...fileExplorerProps} />
    </>
  );
}
